import React from "react";
import Layout from "../../components/Layout";
import ScrollToTop from "../../components/ScrollToTop";
import SessionCheck from "../../components/SessionCheck";
import NavHeader from "../../components/NavHeader";
import MortgageProperty from "../../views/MortgageView/property-view";

const ExternalPropertyInfo = () => {
  return (
    <Layout>
      <ScrollToTop />
      <SessionCheck shouldRedirect />
      <NavHeader pageTitle="Mortgage" routeName="mortgage" />
      <MortgageProperty />
    </Layout>
  );
};

export default ExternalPropertyInfo;
